module.exports = __webpack_public_path__ + "media/images/case-studies/bfc_logo_square-2ec639d69d387f0d21d0e66ae6707911.png";